export const WordCountEvent = 'WordCountEvent'
